import { Component } from '@angular/core';

@Component({
  selector: 'app-servicer-nav',
  templateUrl: './servicer-nav.component.html',
  styleUrls: ['./servicer-nav.component.css']
})
export class ServicerNavComponent {

}
